module.exports = __webpack_public_path__ + "img/green.8760fd14.png";